import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import ListItem from '@wix/da-ds/pkg/List/ListItem';
import { BiData, } from '@wix/da-bi/pkg/events';
import DiscordModuleLoaderLazy from '../../../Discord/redux/ModuleLoaderLazy';
var ConnectDiscord = function (_a) {
    var _b, _c, _d, _e;
    var deviation = _a.deviation, subscriberConnect = _a.subscriberConnect;
    var t = useTranslation().t;
    if (!((_c = (_b = deviation.tier) === null || _b === void 0 ? void 0 : _b.discord) === null || _c === void 0 ? void 0 : _c.connected)) {
        // The tier author hasn't connected their discord server
        return null;
    }
    if ((_e = (_d = deviation.tier) === null || _d === void 0 ? void 0 : _d.discord) === null || _e === void 0 ? void 0 : _e.oauth2) {
        return (React.createElement(Suspense, { fallback: null },
            React.createElement(DiscordModuleLoaderLazy, null),
            React.createElement(ListItem, { label: t('deviationview.tierCard.moreActionsMenu.item.connectDiscord'), onClick: function () { return subscriberConnect(deviation); }, biData: BiData({
                    evid: 555,
                    itemid: deviation.deviationId,
                }) })));
    }
    return null;
};
ConnectDiscord.displayName = 'ConnectDiscord';
export default ConnectDiscord;
//# sourceMappingURL=ConnectDiscord.js.map